import React from 'react';
import {
  DesignedForDevelopersContent,
  FolderCard,
  GlassesFeatureCard,
  SpatialComputingContent,
} from '../utils/IndustriesData/IndustriesData';
import { imagePath } from '../utils/imagePath';
import ARGlassesFeatures from '../utils/IndustriesData/ARGlassesFeatures';
import ARFeatureGrid from '../utils/IndustriesData/ARGlassesFeatures';
import { hotspots } from '../components/data/data/OperatinSystem/OperatingSystem';

export const OperatingSystem = () => {
  return (
    <div className="bg-white min-h-screen w-full relative overflow-hidden">
      {/* Hero Text Section */}
      <>
        {/* Mobile View */}
        <div className="md:hidden relative w-full">
          <div className="bg-black px-6 pt-32 pb-8">
            <h1 className="text-white mb-4">
              <span className="text-4xl font-bold">Spatial </span>
              <span className="text-4xl font-bold text-red-600">OS</span>
            </h1>
            <p className="text-gray-400 text-base">
              Lightweight, responsive & purpose-built for
              <br />
              total immersion.
            </p>
          </div>

          <div className="relative bg-white" style={{ height: '300px' }}>
            {/* Grid Background WITH MASK */}
            <div
              className="absolute inset-0 z-0"
              style={{
                backgroundImage: `
  linear-gradient(to right, rgba(220, 220, 220, 0.5) 2px, transparent 2px),
  linear-gradient(to bottom, rgba(220, 220, 220, 0.5) 2px, transparent 2px)
`,
                backgroundSize: '80px 80px',
                maskImage: `
        linear-gradient(to right, transparent 0%, black 40%, black 60%, transparent 100%),
        linear-gradient(to bottom, transparent 0%, black 30%, black 70%, transparent 100%)
      `,
                WebkitMaskImage: `
        linear-gradient(to right, transparent 0%, black 40%, black 60%, transparent 100%),
        linear-gradient(to bottom, transparent 0%, black 30%, black 70%, transparent 100%)
      `,
                maskComposite: 'intersect',
                WebkitMaskComposite: 'source-in',
              }}
            />

            {/* VR Lady Image */}
            <div className="absolute left-1/2 top-8 -translate-x-1/2 z-20 w-[220px]">
              <img
                src={imagePath?.VRLady}
                alt="VR Person"
                className="w-full object-contain"
              />
            </div>

            {/* Floating Text Card */}
            <div className="absolute left-2/3 top-[180px] -translate-x-1/2 z-30">
              <div className="bg-white/90 backdrop-blur-lg text-black text-xs px-2 py-2 rounded-xl shadow-lg text-center">
                Built for Space.
                <br />
                Designed for People
              </div>
            </div>
          </div>
        </div>

        {/* Tablet and Desktop View */}
        <div className="hidden md:block relative">
          <div className="max-w-7xl mx-auto  md:px-10   pt-64 relative z-[99]">
            <h1 className=" font-bold mb-4 text-[#080808]">
              <img
                className=" w-96"
                src={imagePath?.SpatilOs}
                alt="Spatial OS"
              />
            </h1>
            <p className="text-xl font-medium text-[#040404]">
              Lightweight, responsive, & purpose-
              <br />
              built for total immersion.
            </p>
          </div>
          <div className="absolute md:right-20   top-36  z-[20] pointer-events-none ">
            <div className="absolute top-[368px] sm:left-24 md:left-56 text-nowrap bg-white/50 backdrop-blur-lg text-black text-[10px] md:text-xs lg:text-sm px-2 md:px-4 lg:px-5 py-1.5 md:py-2 lg:py-3 rounded-lg md:rounded-xl shadow-lg z-30">
              {' '}
              Built for Space.
              <br />
              Designed for People
            </div>
            <img
              src={imagePath?.VRLady}
              alt="Spatial OS Human"
              className=" sm:w-[220px] md:w-[460px] relative md:top-3 md:left-5 object-contain"
            />
          </div>
          <div
            className="absolute left-0 w-full flex justify-center pointer-events-none z-0"
            style={{ top: '0', height: '70vh' }}
          >
            <div
              className=" w-full h-full relative"
              style={{
                backgroundImage: `
                linear-gradient(to right, rgba(220, 220, 220, 0.5) 2px, transparent 2px),
                linear-gradient(to bottom, rgba(220, 220, 220, 0.5) 2px, transparent 2px)
              `,
                backgroundSize: '80px 80px',
                maskImage: `
                linear-gradient(to right, transparent 0%, black 40%, black 60%, transparent 100%),
                linear-gradient(to bottom, transparent 0%, black 30%, black 70%, transparent 100%)
              `,
                WebkitMaskImage: `
                linear-gradient(to right, transparent 0%, black 40%, black 60%, transparent 100%),
                linear-gradient(to bottom, transparent 0%, black 30%, black 70%, transparent 100%)
              `,
                maskComposite: 'intersect',
                WebkitMaskComposite: 'source-in',
              }}
            />
          </div>
        </div>
      </>
      <div className="w-full mx-auto relative z-10 -mt-32 pt-40">
        {/* Mobile View */}
        <div className="block md:hidden bg-[#121316] w-full -mt-3 px-6 py-8">
          <SpatialComputingContent />
        </div>
        {/* Desktop View */}
        <div className="hidden md:block">
          <CutCard2>
            <SpatialComputingContent />
          </CutCard2>
        </div>

        <div className="block md:hidden bg-[#121316] w-full px-6 ">
          <DesignedForDevelopersContent />
        </div>

        <CutCard className="w-full hidden md:block">
          <DesignedForDevelopersContent />
        </CutCard>
      </div>
      {/* Mobile View */}
      <div className="block md:hidden w-full bg-[#121316]">
        {/* Title */}
        <div className="text-center py-8 px-4">
          <h1 className="text-xl text-white font-light">
            The Apex of Immersive Engineering
          </h1>
        </div>

        {/* MR Glasses Image with Grid Background - Full Width */}
        <div className="relative w-full bg-white py-8">
          {/* Grid Background */}
          <div
            className="absolute inset-0 w-full h-full"
            style={{
              backgroundImage: `
        linear-gradient(to right, #dcdcdc 1px, transparent 1px),
        linear-gradient(to bottom, #dcdcdc 1px, transparent 1px)
      `,
              backgroundSize: '40px 40px',
              maskImage: `
        linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%),
        linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)
      `,
              WebkitMaskImage: `
        linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%),
        linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)
      `,
              maskComposite: 'intersect',
              WebkitMaskComposite: 'source-in',
            }}
          />

          {/* Image with Hotspots */}
          <div className="relative px-4">
            <div className="relative w-full">
              <img
                src={imagePath?.MRGlassesWeb2}
                alt="Spatial Computing"
                className="w-full h-auto object-contain"
              />

              {/* Hotspots overlay for mobile */}
              {hotspots.map((hotspot) => (
                <div
                  key={hotspot.id}
                  className="absolute md:hidden"
                  style={{
                    left: hotspot.x,
                    top: hotspot.y,
                    transform: 'translate(-50%, -50%)',
                  }}
                >
                  <div className="relative flex items-center justify-center group">
                    {/* Soft pulse */}
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <div className="w-7 h-7 rounded-full bg-cyan-400/60 blur-sm animate-glowPulse" />
                    </div>

                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <div
                        className="w-7 h-7 rounded-full bg-cyan-400/60 blur-sm animate-glowPulse"
                        style={{ animationDelay: '1s' }}
                      />
                    </div>

                    <button className="relative w-5 h-5 rounded-full border border-[#06E7F566] flex items-center justify-center transition-transform duration-300 shadow-md shadow-[#06E7F566] hover:scale-105 z-10">
                      <div className="w-3 h-3 rounded-full bg-cyan-400" />
                    </button>

                    {/* Single L-shaped line */}
                    <div
                      className="absolute z-0 transition-opacity duration-500 opacity-0 group-hover:opacity-100 pointer-events-none"
                      style={{
                        [hotspot.direction === 'left' ? 'right' : 'left']:
                          '10px',
                        [hotspot.verticalDirection === 'up' ? 'bottom' : 'top']:
                          '10px',
                        width:
                          hotspot.mobileHorizontalLength ||
                          hotspot.horizontalLength ||
                          '50px',
                        height:
                          hotspot.mobileVerticalLength ||
                          hotspot.verticalLength ||
                          '100px',

                        ...(hotspot.firstLine === 'vertical'
                          ? {
                              borderLeft:
                                hotspot.direction === 'right'
                                  ? '1.5px solid #131313'
                                  : 'none',
                              borderRight:
                                hotspot.direction === 'left'
                                  ? '1.5px solid #131313'
                                  : 'none',
                              borderBottom:
                                hotspot.verticalDirection === 'down'
                                  ? '1.5px solid #131313'
                                  : 'none',
                              borderTop:
                                hotspot.verticalDirection === 'up'
                                  ? '1.5px solid #131313'
                                  : 'none',
                            }
                          : {
                              borderTop:
                                hotspot.verticalDirection === 'down'
                                  ? '1.5px solid #131313'
                                  : 'none',
                              borderBottom:
                                hotspot.verticalDirection === 'up'
                                  ? '1.5px solid #131313'
                                  : 'none',
                              borderRight:
                                hotspot.direction === 'right'
                                  ? '1.5px solid #131313'
                                  : 'none',
                              borderLeft:
                                hotspot.direction === 'left'
                                  ? '1.5px solid #131313'
                                  : 'none',
                            }),
                      }}
                    />

                    {/* Info panel - line ends at center of box edge */}
                    <div
                      className="absolute w-auto max-w-[200px] bg-[#262626] rounded-lg px-3 py-2 shadow-xl z-50 whitespace-nowrap transition-all duration-500 opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 pointer-events-none"
                      style={{
                        [hotspot.direction === 'left' ? 'right' : 'left']:
                          `calc(10px + ${hotspot.mobileHorizontalLength || hotspot.horizontalLength || '50px'})`,
                        [hotspot.verticalDirection === 'up' ? 'bottom' : 'top']:
                          `calc(10px + ${hotspot.mobileVerticalLength || hotspot.verticalLength || '100px'})`,
                        transform:
                          hotspot.firstLine === 'vertical'
                            ? 'translateY(-50%)'
                            : 'translateX(-50%)',
                        transitionDelay: '200ms',
                      }}
                    >
                      <h3 className="text-white font-normal text-xs">
                        {hotspot.label}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="px-4 py-8 space-y-4">
          {/* Dynamic Environment Anchoring */}
          <div className="bg-[#212121] rounded-lg px-4 py-3 flex items-start gap-3">
            <div className="w-10 h-10 flex-shrink-0 bg-[#393939] rounded-full flex items-center justify-center">
              <img className="h-6 w-6" src={imagePath?.environment} alt="" />
            </div>
            <div className="flex-1">
              <h3 className="text-[#D8D8D8] font-semibold font-jakarta text-sm mb-1">
                Dynamic Environment Anchoring
              </h3>
              <p className="text-[#8E8E8E] text-xs font-normal leading-relaxed">
                Objects stay precisely aligned to real-world surfaces in real
                time.
              </p>
            </div>
          </div>

          {/* Gesture & Gaze Navigation */}
          <div className="bg-[#212121] rounded-lg px-4 py-3 flex items-start gap-3">
            <div className="w-10 h-10 flex-shrink-0 bg-[#393939] rounded-full flex items-center justify-center">
              <img className="h-6 w-6" src={imagePath?.gesture} alt="" />
            </div>
            <div className="flex-1">
              <h3 className="text-[#D8D8D8] font-semibold font-jakarta text-sm mb-1">
                Gesture & Gaze Navigation
              </h3>
              <p className="text-[#8E8E8E] text-xs font-normal leading-relaxed">
                Hands and eye movement enable natural interaction without
                visible UI.
              </p>
            </div>
          </div>
          {/* Multi-User Presence */}
          <div className="bg-[#212121] rounded-lg px-4 py-3 flex items-start gap-3">
            <div className="w-10 h-10 flex-shrink-0 bg-[#393939] rounded-full  flex items-center justify-center">
              <img className="h-6 w-6" src={imagePath?.multiUser} alt="" />
            </div>
            <div className="flex-1">
              <h3 className="text-[#D8D8D8] font-semibold font-jakarta text-sm mb-1">
                Multi-User Presence
              </h3>
              <p className="text-[#8E8E8E] text-xs font-normal leading-relaxed">
                Multiple users share and continue spatial sessions together.
              </p>
            </div>
          </div>
          {/* Low-Latency Spatial Awareness */}
          <div className="bg-[#212121] rounded-lg px-4 py-3 flex items-start gap-3">
            <div className="w-10 h-10 flex-shrink-0 bg-[#393939] rounded-full flex items-center justify-center">
              <img className="h-6 w-6" src={imagePath?.letency} alt="" />
            </div>
            <div className="flex-1">
              <h3 className="text-[#D8D8D8] font-semibold font-jakarta text-sm mb-1">
                Low-Latency Spatial Awareness
              </h3>
              <p className="text-[#8E8E8E] text-xs font-normal leading-relaxed">
                Real-time environmental sensing for instant interaction.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop/Tablet View - Original Code */}
      <div className="hidden md:block relative w-full flex justify-center mt-12 min-h-[70vh]">
        <div
          className="absolute max-w-7xl left-1/2 -translate-x-1/2 items-center w-full h-full"
          style={{
            backgroundImage: `
  linear-gradient(to right, rgba(220, 220, 220, 0.5) 2px, transparent 2px),
  linear-gradient(to bottom, rgba(220, 220, 220, 0.5) 2px, transparent 2px)
`,
            backgroundSize: '80px 80px',
            maskImage: `
              linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%),
              linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)
            `,
            WebkitMaskImage: `
              linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%),
              linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)
            `,
            maskComposite: 'intersect',
            WebkitMaskComposite: 'source-in',
          }}
        />

        {/* Content with Image */}
        <div className="relative z-0 flex flex-col items-center justify-center px-8 py-2 w-full">
          {/* Title */}
          <div className="mb-36">
            <h1 className="text-4xl text-[#282828] font-light text-center">
              The Apex of Immersive Engineering
            </h1>
          </div>

          <div className="max-w-7xl w-full">
            {/* Image Container with Feature Cards */}
            <div className="relative w-full max-w-5xl mx-auto">
              {/* Feature Card 1 - Top Left */}
              <div className="absolute z-20 top-[-200px] md:top-[-35%] left-[5%] md:left-[0%]">
                <GlassesFeatureCard
                  curvePosition="bottom-right"
                  iconSrc={imagePath?.gesture}
                  title="Gesture & gaze-"
                  desc="Control your environment with intuitive hand gestures and eye tracking."
                />
              </div>

              {/* Feature Card 2 - Top Center */}
              <div className="absolute z-20 top-[-24%] left-[55%] md:left-[56%] xl:left-[53%] transform -translate-x-3/4">
                <GlassesFeatureCard
                  curvePosition="top-left"
                  iconSrc={imagePath?.letency}
                  title="Low-latency"
                  desc="spatial awareness for real-time interaction"
                />
              </div>

              {/* Feature Card 3 - Top Right */}
              <div className="absolute z-20 top-[-36%] right-[1%] md:right-[-4%] xl:right-0 transform translate-y-1/10">
                <GlassesFeatureCard
                  curvePosition="top-left"
                  iconSrc={imagePath?.multiUser}
                  title="Multi-user"
                  desc="shared presence across persistent spatial sessions"
                />
              </div>

              {/* Feature Card 4 - Middle Left */}
              <div className="absolute z-20 top-[-47%] left-[40%] md:left-[38%] transform translate-y-1/10">
                <GlassesFeatureCard
                  curvePosition="bottom-right"
                  iconSrc={imagePath?.environment}
                  title="Dynamic environment-object"
                  desc="anchoring for real-world precision"
                />
              </div>

              {/* MR Glasses Image */}
              <div className="rounded-2xl overflow-hidden relative z-10 mt-32">
                <div className="relative w-full">
                  <img
                    src={imagePath?.MRGlassesWeb2}
                    alt="Spatial Computing"
                    className="w-full h-auto object-contain"
                  />

                  {/* Hotspots overlay */}
                  {hotspots.map((hotspot) => (
                    <div
                      key={hotspot.id}
                      className="absolute hidden md:block"
                      style={{
                        left: hotspot.x,
                        top: hotspot.y,
                        transform: 'translate(-50%, -50%)',
                      }}
                    >
                      <div className="relative flex items-center justify-center group">
                        {/* Soft pulse */}
                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                          <div className="w-9 h-9 rounded-full bg-cyan-400/40 animate-glowPulse" />
                        </div>
                        <button className="relative w-7 h-7 rounded-full border border-[#06E7F566] flex items-center justify-center transition-transform duration-300 shadow-md shadow-[#06E7F566] hover:scale-105 z-10">
                          <div className="w-4 h-4 rounded-full bg-cyan-400" />
                        </button>
                        {/* Single L-shaped line */}
                        <div
                          className="absolute z-0 transition-opacity duration-500 opacity-0 group-hover:opacity-100 pointer-events-none"
                          style={{
                            [hotspot.direction === 'left' ? 'right' : 'left']:
                              '14px',
                            [hotspot.verticalDirection === 'up'
                              ? 'bottom'
                              : 'top']: '14px',
                            width: hotspot.horizontalLength || '100px',
                            height: hotspot.verticalLength || '100px',

                            ...(hotspot.firstLine === 'vertical'
                              ? {
                                  borderLeft:
                                    hotspot.direction === 'right'
                                      ? '1.5px solid #131313'
                                      : 'none',
                                  borderRight:
                                    hotspot.direction === 'left'
                                      ? '1.5px solid #131313'
                                      : 'none',
                                  borderBottom:
                                    hotspot.verticalDirection === 'down'
                                      ? '1.5px solid #131313'
                                      : 'none',
                                  borderTop:
                                    hotspot.verticalDirection === 'up'
                                      ? '1.5px solid #131313'
                                      : 'none',
                                }
                              : {
                                  borderTop:
                                    hotspot.verticalDirection === 'down'
                                      ? '1.5px solid #131313'
                                      : 'none',
                                  borderBottom:
                                    hotspot.verticalDirection === 'up'
                                      ? '1.5px solid #131313'
                                      : 'none',
                                  borderRight:
                                    hotspot.direction === 'right'
                                      ? '1.5px solid #131313'
                                      : 'none',
                                  borderLeft:
                                    hotspot.direction === 'left'
                                      ? '1.5px solid #131313'
                                      : 'none',
                                }),
                          }}
                        />

                        <div
                          className="absolute w-auto max-w-[250px] bg-[#262626] rounded-lg px-4 py-3 shadow-xl z-50 whitespace-nowrap transition-all duration-500 opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 pointer-events-none"
                          style={{
                            [hotspot.direction === 'left' ? 'right' : 'left']:
                              `calc(14px + ${hotspot.horizontalLength || '100px'})`,
                            [hotspot.verticalDirection === 'up'
                              ? 'bottom'
                              : 'top']:
                              `calc(14px + ${hotspot.verticalLength || '100px'})`,
                            transform:
                              hotspot.firstLine === 'vertical'
                                ? 'translateY(-50%)'
                                : 'translateX(-50%)',
                            transitionDelay: '200ms',
                          }}
                        >
                          <h3 className="text-white font-normal text-sm">
                            {hotspot.label}
                          </h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="block md:hidden bg-[#121316] w-full">
        <ARFeatureGrid />
      </div>

      {/* This whole block should be hidden on mobile */}
      <div className="hidden md:block -mt-24 md:-mt-32">
        <FolderCard>
          <ARFeatureGrid />
        </FolderCard>
      </div>
      {/* <div className="relative w-full overflow-hidden">
        <div className="block md:hidden pt-6 pb-8 bg-[#121316]">
          <div className="px-4 mb-4">
            <h3 className="text-[20px] font-semibold text-white leading-tight">
              Engineered for Performance.
              <br />
              Optimized for Immersion.
            </h3>
          </div>

          <div className="relative mx-4 rounded-[18px] overflow-hidden">
            <img
              src={imagePath?.OsGrid}
              alt=""
              className="w-full h-[260px] object-cover"
            />

            <img
              src={imagePath?.ImmersionGlass}
              alt="VR Glasses"
              className="
        absolute
        top-1/2
        left-1/2
        -translate-x-1/2
        -translate-y-1/2
        w-[240px]
        object-contain
        z-20
        pointer-events-none
      "
            />
          </div>

          <div className="px-4 mt-4">
            <p className="text-[16px] text-[#E0DEDE] leading-relaxed font-normal ">
              Built for performance and scale, SpatialOS is designed to optimize
              the use of memory, system resources, processing of information,
              and analytics. This achieves the goal of ensuring the experiences
              developed do not have a big memory footprints in turn optimizing
              the usage of compute power while providing rich immersive
              experiences to the user.
            </p>
          </div>
        </div>

        <img
          className="hidden md:block w-full h-[520px] lg:h-[800px] object-cover"
          src={imagePath?.OsGrid}
          alt=""
        />

        <div
          style={{ background: '#05151D66' }}
          className="hidden md:block border-2 border-white/20 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[88%] md:left-[42%] lg:left-1/2
      lg:w-[82%] xl:w-[62%] md:pr-[140px] lg:pr-[220px] backdrop-blur-sm rounded-[18px] shadow-lg px-6 py-7 md:px-10 md:py-10 z-20"
        >
          <div className="grid grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-[20px] lg:text-[26px] font-semibold text-white mb-3 leading-tight">
                Engineered for Performance.
                <br />
                Optimized for Immersion.
              </h3>

              <p className="text-sm lg:text-base text-[#E0DEDE] leading-relaxed max-w-md">
                Built for performance and scale, SpatialOS is designed to
                optimize the use of memory, system resources, processing of
                information, and analytics. This achieves the goal of ensuring
                the experiences developed do not have a big memory footprints in
                turn optimizing the usage of compute power while providing rich
                immersive experiences to the user.
              </p>
            </div>

            <div className="relative h-64"></div>
          </div>
        </div>

        <img
          src={imagePath?.ImmersionGlass}
          alt="VR Glasses"
          className="
      hidden md:block
      absolute
      bottom-0
      right-[-60px]
      md:right-[-100px]
      lg:right-0
      w-[380px]
      lg:w-[620px]
      xl:w-[760px]
      object-contain
      z-30
      pointer-events-none
    "
        />
      </div> */}
    </div>
  );
};

const CutCard2 = ({ children, className = '' }) => {
  return (
    <div className={`relative w-full  mx-auto ${className}`}>
      <svg className="absolute w-0 h-0" aria-hidden="true">
        <defs>
          <clipPath id="spatial-mask-path" clipPathUnits="objectBoundingBox">
            <path
              d="
                M 0.03,0.1
                H 0.56
                C 0.585,0.1 0.6,0.03 0.64,0.03
                H 0.97
                A 0.03,0.03 0,0,1 1,0.06
                V 0.9
                A 0.03,0.03 0,0,1 0.97,0.93
                H 0.44
                C 0.415,0.93 0.4,1.0 0.36,1.0
                H 0.03
                A 0.03,0.03 0,0,1 0,0.97
                V 0.13
                A 0.03,0.03 0,0,1 0.03,0.1
                Z
              "
            />
          </clipPath>
        </defs>
      </svg>
      <div
        className="bg-[#080808] text-white px-10 md:py-32 min-h-[840px] relative overflow-hidden"
        style={{ clipPath: 'url(#spatial-mask-path)' }}
      >
        <div className="absolute top-0 right-0 w-[50%] h-[50%] bg-zinc-800/20 blur-[150px] rounded-[10px] -mr-20 -mt-20" />
        <div className="absolute bottom-0 left-0 w-[40%] h-[40%] bg-zinc-900/30 blur-[120px] rounded-[10px] -ml-20 -mb-20" />

        <div className="relative z-10 h-full flex flex-col">{children}</div>
      </div>
    </div>
  );
};

const CutCard = ({ children, className = '' }) => {
  return (
    <div className={`relative w-full  mx-auto ${className}`}>
      <svg className="absolute w-0 h-0" aria-hidden="true">
        <defs>
          <clipPath
            id="industrial-cut-path-subtle"
            clipPathUnits="objectBoundingBox"
          >
            <path
              d="
                M 0,0.12
                C 0,0.1 0.01,0.09 0.03,0.09 
                H 0.365
                C 0.41,0.09 0.43,0 0.48,0 
                H 0.95 
                A 0.05,0.05 0,0,1 1,0.05
                V 0.95
                A 0.05,0.05 0,0,1 0.95,1
                H 0.48
                C 0.43,1 0.41,0.91 0.365,0.91 
                H 0.03 
                C 0.01,0.91 0,0.9 0,0.88 
                V 0.12 
                Z
              "
            />
          </clipPath>
        </defs>
      </svg>

      <div
        className="bg-[#050505] text-white px-10 min-h-[600px] relative "
        style={{ clipPath: 'url(#industrial-cut-path-subtle)' }}
      >
        <div className="absolute top-0 right-0 w-[50%] h-[40%] bg-zinc-800/15 blur-[100px] rounded-full -mr-20 -mt-20" />

        <div className="relative z-10 h-full flex flex-col">{children}</div>
      </div>
    </div>
  );
};
